import { genRetrieveMapboxUrl } from '@/hooks/useMapboxQuery';
import apiRequest from '@/services/apiRequest';
import { IMapboxRetrievedSuggestion } from '@/services/types/mapbox/mapboxApi';

interface MapboxValue {
  mapbox_id: string;
  full_address?: string;
}

/**
 * Retrieves the full address from Mapbox API for a given mapbox_id if full_address is not already available
 * @param value - Object containing mapbox_id and optional full_address
 * @returns Promise<string> - The full address or empty string if retrieval fails
 */
export const retrieveMapboxFullAddress = async (value: MapboxValue): Promise<string> => {
  try {
    if (value?.full_address) {
      return value.full_address;
    }

    const mapboxUrl = genRetrieveMapboxUrl(value.mapbox_id);
    if (!mapboxUrl) {
      return '';
    }

    const retrievedSuggestion = await apiRequest<IMapboxRetrievedSuggestion>({
      url: mapboxUrl,
    });

    const fullAddress = retrievedSuggestion.features[0]?.properties.full_address || '';

    return fullAddress;
  } catch {
    return '';
  }
};
